import ProductoManagementPage from '../pages/ProductoManagementPage'

const routes = [
    { name: 'ProductoManagementPage', path: '/producto-management', component: ProductoManagementPage },
]

export default routes;
